var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CInput',{staticClass:"currency-input",attrs:{"type":"number","min":_vm.min,"step":_vm.step,"value":_vm.value,"prepend":_vm.currencySymbol(_vm.currency),"append":_vm.currency},on:{"input":_vm.onInput,"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }